import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import { orderType } from '@/config';
import ListOrder from '../ListOrder';
import { HiOutlineArrowSmLeft } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';

interface props {
    isOpen: boolean;
    onClose: () => void;
    orderObj: orderType[];
    fetchOrderByTableId: () => void;
    isCate: boolean;
    contentHeight: number;
    tableId: string
}

export default function CartDrawer({ isOpen, onClose, orderObj, fetchOrderByTableId, isCate, tableId }: props) {
    const { t } = useTranslation();

    const tableName = localStorage.getItem("tableName");

    return (
        <>
            <Drawer
                open={isOpen}
                onClose={onClose}
                direction="bottom"
                className='min-h-screen overflow-hidden bg-[#F1F2F5]'
            >
                <div className="flex justify-between items-center w-full py-3 px-4 bg-[#F1F2F5]">
                    <div className="flex items-center gap-2">
                        <div
                            className="px-4 py-1 md:py-2 bg-white rounded-md"
                            onClick={onClose}
                        >
                            <HiOutlineArrowSmLeft size={24} />
                        </div>
                        <h3 className="text-base md:text-2xl font-medium">{t('order')}</h3>
                    </div>
                    <div className="px-4 py-2 rounded-full text-gray-500 bg-white">{tableName}</div>
                </div>
                <div className="px-2 h-full">
                    <ListOrder fetchOrderByTableId={() => fetchOrderByTableId()} orderObj={orderObj} tableId={tableId ? tableId : ""} isCate={isCate} />
                </div>
            </Drawer>
        </>
    )
}
